import React from 'react';
import { Link } from 'react-router-dom';
import { FileText, TrendingUp, Camera, Shield, Award, CheckCircle, ArrowRight } from 'lucide-react';
import { Card, CardContent, CardHeader, CardTitle } from '../components/ui/card';
import { Button } from '../components/ui/button';
import { services } from '../data/mock';

const iconMap = {
  FileText,
  TrendingUp,
  Camera,
  Shield,
  Award,
  CheckCircle
};

export const ServicesPage = () => {
  return (
    <div className="min-h-screen">
      {/* Header Section */}
      <section className="bg-slate-900 text-white py-16">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="max-w-3xl">
            <h1 className="text-4xl lg:text-5xl font-bold mb-6">Unsere Leistungen</h1>
            <p className="text-lg text-gray-300">
              Als geprüfter KFZ-Sachverständiger bieten wir Ihnen ein umfassendes Leistungsspektrum. 
              Alle Gutachten werden nach anerkannten Standards erstellt.Nach bestem Wissen und Gewissen erledigen wir Ihre Angelegenheiten auf höchsten Qualitätsanforderungen. 
            </p>
          </div>
        </div>
      </section>

      {/* Services Grid */}
      <section className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid md:grid-cols-2 gap-8">
            {services.map((service) => {
              const IconComponent = iconMap[service.icon];
              return (
                <Card key={service.id} className="hover:shadow-xl transition-all hover:-translate-y-1 border-t-4 border-t-forest-600">
                  <CardHeader>
                    <div className="w-14 h-14 bg-forest-100 rounded-lg flex items-center justify-center mb-4">
                      <IconComponent className="h-7 w-7 text-forest-700" />
                    </div>
                    <CardTitle className="text-2xl text-slate-900">{service.title}</CardTitle>
                  </CardHeader>
                  <CardContent>
                    <p className="text-gray-600 leading-relaxed">{service.description}</p>
                  </CardContent>
                </Card>
              );
            })}
          </div>
        </div>
      </section>

      {/* Process Section */}
      <section className="py-20 bg-slate-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid lg:grid-cols-2 gap-12 items-center">
            <div>
              <h2 className="text-3xl lg:text-4xl font-bold text-slate-900 mb-6">
                Professionelle Begutachtung mit modernster Technik
              </h2>
              <p className="text-gray-600 mb-6">
                Wir verfügen über langjährige Erfahrung und nutzen modernste Messtechnik 
                für präzise Schadensbewertungen. Jedes Gutachten wird nach anerkannten Standards erstellt.
              </p>
              <ul className="space-y-3 mb-8">
                <li className="flex items-start gap-3">
                  <CheckCircle className="h-6 w-6 text-forest-600 flex-shrink-0 mt-0.5" />
                  <span className="text-gray-700">Demontage von Fahrzeugteilen zur Aufdeckung versteckter Schäden</span>
                </li>
                <li className="flex items-start gap-3">
                  <CheckCircle className="h-6 w-6 text-forest-600 flex-shrink-0 mt-0.5" />
                  <span className="text-gray-700">Detaillierte Fotodokumentation mit professioneller Ausrüstung</span>
                </li>
                <li className="flex items-start gap-3">
                  <CheckCircle className="h-6 w-6 text-forest-600 flex-shrink-0 mt-0.5" />
                  <span className="text-gray-700">Präzise Lackschichtdickenmessung zur Unfallhistorie</span>
                </li>
                <li className="flex items-start gap-3">
                  <CheckCircle className="h-6 w-6 text-forest-600 flex-shrink-0 mt-0.5" />
                  <span className="text-gray-700">Umfassende Marktrecherche für Wertgutachten</span>
                </li>
                <li className="flex items-start gap-3">
                  <CheckCircle className="h-6 w-6 text-forest-600 flex-shrink-0 mt-0.5" />
                  <span className="text-gray-700">Digitale Gutachten mit schneller Bearbeitung</span>
                </li>
              </ul>
              <Link to="/arbeitsweise">
                <Button size="lg" className="bg-forest-600 hover:bg-forest-700 text-white">
                  Mehr über unsere Arbeitsweise
                  <ArrowRight className="ml-2 h-5 w-5" />
                </Button>
              </Link>
            </div>

            <div className="relative">
              <div className="aspect-[4/3] rounded-2xl overflow-hidden shadow-xl">
                <img
                  src="/Werkzeuge.jpeg"
                  alt="Professionelle Fahrzeugbegutachtung - Demontage zur Schadensermittlung"
                  className="w-full h-full object-cover"
                />
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-16 bg-forest-700 text-white">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h2 className="text-3xl font-bold mb-4">Haben Sie Fragen zu unseren Leistungen?</h2>
          <p className="text-lg text-forest-100 mb-8">
            Wir beraten Sie gerne kostenlos und unverbindlich zu Ihrem individuellen Fall.
          </p>
          <Link to="/kontakt">
            <Button size="lg" className="bg-white text-forest-700 hover:bg-gray-100">
              Jetzt Kontakt aufnehmen
              <ArrowRight className="ml-2 h-5 w-5" />
            </Button>
          </Link>
        </div>
      </section>
    </div>
  );
};
